export const MAX_CONTENT_ID_COUNT = 60;
export const CONTENT_TYPE_OPTIONS = [
    "articles",
    "audio",
    "calculators",
    "contests",
    "downloads",
    "full-webinar-videos",
    "gps-to-success",
    "infographics",
    "landing",
    "start",
    "videos",
    "webinar-clip-videos",
];

export const parseContentIds = (value) => {
    if (!value) {
        return [];
    }

    return Array.from(
        new Set(
            value
                .split(/[\s,]+/)
                .map((item) => Number.parseInt(item.trim(), 10))
                .filter((item) => Number.isInteger(item) && item > 0)
        )
    ).slice(0, MAX_CONTENT_ID_COUNT);
};

export const getErrorMessage = (error, fallbackMessage) => {
    return (
        error?.response?.data?.errors?.[0]?.errorMessage ||
        error?.response?.data ||
        error?.message ||
        fallbackMessage
    );
};
